/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import { CancelPresentationRounded } from '@mui/icons-material';
import { Box, FormControl, Grid, MenuItem, Select, Typography } from '@mui/material';
import { MANAGING_DIVISIONS } from '../../../utils/constants';

export default function ManageDivisionsDialog({ open, handleClose, rowData, handleSave }) {
  const [division, setDivision] = useState('');

  useEffect(() => {
    setDivision(rowData?.managingDivision || '');
  }, [open]);

  return (
    <React.Fragment>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth='md'
      >
        <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold', fontSize: '18px' }} id="customized-dialog-title">
          Attention!
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={() => ({
            position: 'absolute',
            right: 8,
            top: 8,
          })}
        >
     <CancelPresentationRounded fontSize='large'/>
        </IconButton>
        <DialogContent dividers sx={{ minWidth: '480px', display: 'flex', alignItems: 'center' }}>
          <Grid>
            <Box item>
              <Typography sx={{ fontSize: '16px', mb: 1 }}>
                <strong>Name:</strong> {rowData?.firstName}{' '}
                </Typography>
                 <Typography sx={{ fontSize: '16px' }}>
                <strong>Email:</strong> {rowData?.emailAddress}
              </Typography>
            </Box>
            <Box item display='flex' alignItems='center' mt={2}>
              <Typography fontSize='16px' fontWeight='bold'>Management</Typography>
              <FormControl
                variant="filled"
                size='large'
                sx={{
                  bgcolor: 'transparent',
                  width: 'auto',
                  flex: 1,
                  ml: 2,
                  '& .MuiSelect-select': {
                    paddingTop: '14px',
                    paddingBottom: '14px',
                  },
                }}
              >
                <Select
                  labelId={'division-label'}
                  id={'division-select'}
                  value={division}
                  onChange={(e) => setDivision(e.target.value)}
                  disableUnderline
                  displayEmpty
                  renderValue={(selected) => {
                    if (!selected) {
                      return 'Select Region';
                    }
                    return selected;
                  }}
                >
                  {division
                    ? (
                      <MenuItem key={'item_none'} value={''}>
                        Reset
                      </MenuItem>
                      )
                    : null}
                  {MANAGING_DIVISIONS?.map((item) => (
                    <MenuItem key={`item_${item}`} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => {
            const updatedData = { ...rowData };
            updatedData.managingDivision = division;
            handleSave(updatedData);
            handleClose();
          }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
